import { ProdState } from "./types";
import { addProductView, checkEmail } from "./productTools";
import ProductSkeleton from "./ProductSkeleton";
import Swal from "sweetalert2";

type AEL = {
	node: HTMLElement;
	event: any;
	handler: (event: any) => void;
};
class Product {
	jsProduct: HTMLElement;
	jsPlayView: NodeListOf<HTMLElement>;
	state: ProdState;
	id: number;
	forDestroy: AEL[];
	constructor(jsProduct: HTMLElement) {
		this.id = parseInt(jsProduct?.dataset?.id + "");
		this.jsProduct = jsProduct;
		this.jsPlayView =
			jsProduct.querySelectorAll<HTMLElement>(".jsPlayView");

		this.forDestroy = [];
		this.state = {
			isOpen: false,
			isPlaying: false,
			isTrackLoading: false,
			contentUploaded: false,
		};
	}
	destroy() {
		this.forDestroy.forEach((item) => {
			item.node.removeEventListener(item.event, item.handler);
		});
		this.forDestroy = [];
	}
	addEventListener(ob: AEL) {
		// ob.node.removeEventListener(ob.event, ob.handler);
		if (ob.event === "submit" && ob.node) {
			ob.node.onsubmit = ob.handler;
		} else {
			ob.node.addEventListener(ob.event, ob.handler);
			this.forDestroy.push({
				node: ob.node,
				event: ob.event,
				handler: ob.handler,
			});
		}
	}
	init() {
		this.destroy();
		const jsProduct = this.jsProduct;
		const productId = parseInt(jsProduct?.dataset?.id + "");
		this.id = productId;
		this.jsProduct = jsProduct;

		//
		//
		if (!productId) {
			// alert(jsProduct);
			console.log(jsProduct);
			return false;
		}

		if (jsProduct.classList.contains(`jsloadContent`)) {
			this.openProduct();
		}

		//
		//open
		jsProduct
			.querySelectorAll<HTMLElement>(`.jsOpenProduct`)
			?.forEach((jsOpenProduct) => {
				const isToggle =
					jsOpenProduct.classList.contains(`jsToggleOpenProduct`);
				const handler = () => {
					if (isToggle) {
						this.toggleProduct();
					} else {
						this.openProduct();
					}
				};

				this.addEventListener({
					node: jsOpenProduct,
					event: "click",
					handler: handler,
				});
			});
		jsProduct
			.querySelectorAll<HTMLElement>(`.jsNext`)
			?.forEach((jsNext) => {
				this.addEventListener({
					node: jsNext,
					event: "click",
					handler: () => {
						this.next();
					},
				});
			});
		jsProduct
			.querySelectorAll<HTMLElement>(`.jsPrev`)
			?.forEach((jsPrev) => {
				this.addEventListener({
					node: jsPrev,
					event: "click",
					handler: () => {
						this.prev();
					},
				});
			});

		//jsShowbyOneClickForm
		const showFormHandler = () => {
			jsProduct.classList.add("one-click-is-open");
		};
		jsProduct
			.querySelectorAll<HTMLElement>(`.jsShowbyOneClickForm`)
			?.forEach((jsShowbyOneClickForm) => {
				this.addEventListener({
					node: jsShowbyOneClickForm,
					event: "click",
					handler: showFormHandler,
				});
			});
		const hideFormHandler = () => {
			jsProduct.classList.remove("one-click-is-open");
		};
		jsProduct
			.querySelectorAll<HTMLElement>(`.jsHideByOneClickForm`)
			?.forEach((jsHideByOneClickForm) => {
				this.addEventListener({
					node: jsHideByOneClickForm,
					event: "click",
					handler: hideFormHandler,
				});
			});
		const submitFormHandler = (event: any) => {
			event.preventDefault();
			this.oneClickSubmitHandler(productId, jsProduct);
		};
		this.addEventListener({
			node: jsProduct,
			event: "submit",
			handler: submitFormHandler,
		});

		jsProduct
			.querySelectorAll<HTMLInputElement>(`.jsProductService`)
			?.forEach((_item) => {
				_item.onchange = (event) => {
					const serviceId = (<any>_item).value;
					const input = jsProduct.querySelector<HTMLInputElement>(
						`input[name="comment_${serviceId}"]`
					)!;
					if ((<any>_item).checked) {
						(<any>jsProduct).classList.add(
							`service_id_${serviceId}`
						);
						input.required = true;
					} else {
						(<any>jsProduct).classList.remove(
							`service_id_${serviceId}`
						);
						input.required = false;
					}
				};
			});

		//
		//
		if ((<any>window).tippy) {
			(<any>window).tippy(
				jsProduct.querySelectorAll("[data-tippy-content]")
			);
		}
		if ((<any>window).highligh) {
			(<any>window).highligh();
		}
		if ((<any>window).mdc) {
			(<any>window).mdc.autoInit();
		}
		return false;
	}
	openProduct() {
		if (!this.state.contentUploaded) {
			addProductView(this.id);
			this.loadProductContent();
		}
		// if (!this.jsProduct.classList.contains("is-open")) {
		// }
		this.state.isOpen = true;
		this.onChange();
	}
	toggleProduct() {
		// console.log("toggleProduct", this.state);
		if (this.state.isOpen) {
			this.closeProduct();
		} else {
			this.openProduct();
		}
	}
	closeProduct() {
		this.state.isOpen = false;
		this.onChange();
	}
	next() {}
	prev() {}
	loadProductContent() {
		// console.log("loadProductContent", this);
		// const firstVariant = this.jsProduct.querySelector<HTMLElement>(
		// 	`.bpm-list .js-bpm-load`
		// );
		// const activeVariant = this.jsProduct.querySelector<HTMLElement>(
		// 	`.bpm-list li.active .js-bpm-load`
		// );

		// console.log("click", firstVariant, activeVariant);
		// if (firstVariant?.dataset.bmp !== activeVariant?.dataset.bpm) {
		// }
		// firstVariant?.click();
		// this.state.contentUploaded = true;
		// return false;
		if (this.jsProduct.classList.contains("jsEmptyBpm")) {
			if (!this.state.contentUploaded) {
				const productId = this.id;
				const jsProductContent =
					this.jsProduct.querySelector<HTMLElement>(
						`.jsProductContent`
					);
				if (jsProductContent) {
					jsProductContent.innerHTML = ProductSkeleton;

					fetch(`/ajax-api/product_content.php`, {
						method: "post",
						body: JSON.stringify({ productId: productId }),
					})
						.then((res) => res.json())
						.then((res) => {
							console.log("product_content res", res);
							jsProductContent.innerHTML = res.content;
							this.state.contentUploaded = true;
							this.init();
							this.onChange();
						});
					this.state.contentUploaded = "loading";
				}
			}
		}
	}
	async oneClickSubmitHandler(productId: number, jsProduct: HTMLElement) {
		const jsLoader = document.querySelector<HTMLElement>(`.jsLoader`);
		if (jsProduct) {
			const jsInputEmail = <HTMLInputElement>(
				jsProduct.querySelector(`.jsInputEmail`)
			);
			const formWrap = document.querySelector(
				`.jsByOneClickCheckoutForm`
			);
			if (
				formWrap &&
				jsInputEmail &&
				!jsInputEmail.classList.contains("mdc-text-field--invalid")
			) {
				const email = jsInputEmail.value;
				let data = (<any>window).getProductData(productId);
				// console.log("checkEmail1", await checkEmail(email));
				if (!(await checkEmail(email))) return;
				data.email = email;
				data.lang = (<any>window).langLabel || "ru";
				data.productId = productId;

				jsLoader?.classList.add("isOpen");
				fetch(`/ajax-api/buy_in_one_click.php`, {
					method: "post",
					body: JSON.stringify(data),
				})
					.then((res) => res.json())
					.then((res) => {
						if (res.error) {
							jsLoader?.classList.remove("isOpen");
							Swal.fire({ icon: "error", text: res.error });
							return;
						}

						console.log("res buy_in_one_click", res);
						jsLoader?.classList.remove("isOpen");
						localStorage.setItem("orderUrl", res.order.url);
						if (
							res.order.paid === "1" ||
							res.redirectToOrder == true
						) {
							location.href = "/order/" + res.order.url;
						} else {
							formWrap.innerHTML = res.checkout_form;
							const form = <any>formWrap.querySelector(`form`);
							const sub = form.submit();
						}
					});
			} else {
				alert("err jsInputEmail");
				console.error("formWrap", formWrap);
				console.error("jsInputEmail", jsInputEmail);
				console.error(
					"!contains",
					!jsInputEmail.classList.contains("mdc-text-field--invalid")
				);
				jsLoader?.classList.remove("isOpen");
			}

			jsProduct.classList.add("one-click-is-open");
		}
	}
	onChange(from?: string) {
		if (from) {
			console.log("onChange from", from, this.state);
		}
		this.render();
	}
	setControlPlayClasses(node: HTMLElement, prodState: ProdState) {
		if (prodState.isPlaying) {
			node?.classList.add("isPlaying");
		} else {
			node?.classList.remove("isPlaying");
		}
		if (prodState.isTrackLoading) {
			node?.classList.add("isTrackLoading");
		} else {
			node?.classList.remove("isTrackLoading");
		}
	}
	render() {
		console.log("render", this.id);
		const prodState = this.state;
		const jsProduct = this.jsProduct;

		if (prodState.isOpen) {
			jsProduct.classList.add(`is-open`);
		} else {
			jsProduct.classList.remove(`is-open`);
		}
		// clear list
		const jsPlayItemView =
			jsProduct.querySelectorAll<HTMLElement>(`.jsPlayItemView`);
		jsPlayItemView.forEach((item) => {
			item.classList.remove(`isPlaying`);
			item.classList.remove(`isTrackLoading`);
		});
		// clear list

		const jsControlViewPlay =
			jsProduct.querySelectorAll<HTMLElement>(`.jsControlViewPlay`);
		// console.log("prodState jsControlViewPlay" , prodState ,jsControlViewPlay)
		if (jsControlViewPlay) {
			jsControlViewPlay.forEach((item) => {
				this.setControlPlayClasses(item, prodState);
			});
		}

		// this.jsPlayView.forEach((item) => {
		//     console.log("jsPlayView" , item , prodState);
		// 	this.setControlPlayClasses(item, prodState);
		// });
	}
}
export default Product;
